import React from 'react';
import {createRoot} from 'react-dom/client';
import {hydrateRoot} from 'react-dom/client';
import {Provider} from "mobx-react";
import {createInertiaApp} from '@inertiajs/react';
import {InertiaProgress} from '@inertiajs/progress';
import {resolvePageComponent} from 'laravel-vite-plugin/inertia-helpers';
import rootStores from '@/Stores/RootStores';
import './bootstrap';
import "../fonts/stylesheet.css";
import "@/Scss/index.scss";

InertiaProgress.init({color: '#24564A'});

createInertiaApp({
    title: (title) => `${title}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.jsx`, import.meta.glob('./Pages/**/*.jsx')),
    setup({el, App, props}) {
        const isSSR = !!props.initialPage?.props?.is_ssr;

        if (isSSR) {
            // SSR страница → hydrate
            hydrateRoot(
                el,
                <Provider stores={rootStores}>
                    <App {...props} />
                </Provider>
            );
        } else {
            // CSR страница → обычный рендер
            createRoot(el).render(
                <Provider stores={rootStores}>
                    <App {...props} />
                </Provider>
            );
        }
    },
    defaults: {
        future: {
            useDataInertiaHeadAttribute: true,
        },
    },
});
